$(function($) {
    "use strict";

    var $win = $(window);
    var $body = $(document.body);

    $('[sticky-bottom]').each(function() {
        var $element = $(this);

        var $base = $element.parent();
        var $block = $element;

        var old = null;
        function render() {

            var blockheight = $block.outerHeight();
            if (blockheight !== old) {
                $base.height(blockheight);
                old = blockheight;
            }

            var baseTop = $base.offset().top;
            //var blockTop = block.offset().top;
            var height = window.innerHeight;
            var scrollTop = $win.scrollTop();

            var blockBottom = (scrollTop - baseTop) + height - blockheight;

            //if (baseTop === 0) {
            //    //requestAnimationFrame(render);
            //    return;
            //}

            if (blockBottom >= 0) {
                $block.addClass("stay");
            } else {
                if (/stay/.test($block[0].className)) {
                    $block.removeClass("stay");
                }
            }
        }

        $win.on('scroll', render);
        render();

    });

});